// =====================================================================================
// INVRT Radar — web console — account — Delivery tab
//
// docs/API-CONTRACTS-C1.md §6 and §7: where Radar sends each contact the moment it has
// one. Two sections, each its own surface under ./delivery/:
//
//   WebhooksSection  — signed JSON to the tenant's own HTTPS endpoints (§7): add, test,
//                      pause or resume, rotate the signing secret, delete, deliveries.
//   TargetsSection   — email, HubSpot, Pipedrive, INVRT CRM and MONTI (§6): add with
//                      kind-specific credentials, test, pause or resume, edit, delete,
//                      attempts.
//
// The page shell registers this under the tab id "delivery". Reads are open to every
// member; every mutation is offered to an organisation admin only
// (`activeMembership.is_org_admin`, exactly as SitesPage gates "Add a site"). The server
// enforces the same rule; the flag here only shows or hides.
// =====================================================================================

import { useSession } from "@/auth/SessionProvider";
import { TargetsSection } from "./delivery/TargetsSection";
import { WebhooksSection } from "./delivery/WebhooksSection";

export function DeliveryPanel() {
  const { activeMembership } = useSession();
  const isAdmin = activeMembership?.is_org_admin === true;

  return (
    <div className="flex flex-col gap-6">
      {!isAdmin ? (
        <p className="text-sm text-ink-muted">
          Only an organisation administrator can add, change, test or remove endpoints and
          targets. You can read everything here, including delivery history.
        </p>
      ) : null}
      <WebhooksSection isAdmin={isAdmin} />
      <TargetsSection isAdmin={isAdmin} />
    </div>
  );
}
